// Graduation archive. One entry per graduating class, managed via the CMS.
// Add photos (any number) and YouTube video IDs as each ceremony is published.
export type GraduationPhoto = { src: string; alt: string; caption: string };
export type GraduationVideo = { youtubeId: string; title: string };

export type GraduationClass = {
  year: number;
  /** Ceremony date as it should appear, e.g. "14 June 2026". */
  date?: string;
  venue?: string;
  /** One line on what made this class distinctive. Must be MCC-approved. */
  highlight?: string;
  highlightLink?: { label: string; to: string };
  photos: GraduationPhoto[];
  videos: GraduationVideo[];
};

export const UPCOMING_GRADUATION = {
  classYear: 2027,
  date: "Date to be announced",
};

export const GRADUATIONS: GraduationClass[] = [
  {
    year: 2026,
    highlight: "The highest single scholarship offer to date: CAD $270,500.",
    highlightLink: { label: "Scholarships & results", to: "/academics/scholarships" },
    photos: [],
    videos: [],
  },
  { year: 2025, photos: [], videos: [] },
  { year: 2024, photos: [], videos: [] },
  {
    year: 2023,
    highlight: "An MCC Scholarship recipient received 12 university offers.",
    highlightLink: { label: "Read Deba’s story", to: "/academics/scholarships" },
    photos: [],
    videos: [],
  },
  {
    year: 2022,
    highlight: "Over 90% of graduates received scholarship offers.",
    highlightLink: { label: "Scholarships & results", to: "/academics/scholarships" },
    photos: [],
    videos: [],
  },
  { year: 2021, photos: [], videos: [] },
  { year: 2020, photos: [], videos: [] },
];
